import { useTranslation } from '@/i18n';
import {
  ArrayFrom,
  IconError,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

type Props = {
  messages: string[] | undefined;
};

export const TransactionError: FC<Props> = memo(({ messages }) => {
  const { t } = useTranslation();
  const tooltipContent = useMemo(() => {
    return (
      <div>
        {ArrayFrom(new Set(messages || []), (message) => message).map(
          (message, index) => (
            <div key={index}>
              <>{message}</>
            </div>
          )
        )}
      </div>
    );
  }, [messages]);

  if (!messages?.length) return null;

  return (
    <Tooltip placement='rightTop' title={tooltipContent}>
      <div className='error-container'>
        <IconError size={16} />
        <span>{t('error_text')}</span>
      </div>
    </Tooltip>
  );
});

TransactionError.displayName = 'TransactionError';
